<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN" id="_idParaDest-2"> </p>
<p class="BTspace ParaOverride-1">Also by Sayaka Murata</p>
<p class="BTspace ParaOverride-1"><span class="CharOverride-1">Convenience Store Woman</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97808021570271.vue?4f7d3368